import React from 'react';
import {
  ParamsAndReturnTypes,
  TranslateFunc,
} from '@prisjakt/ui-translate/src/translate-func';
import { SortOption, SortOptionEnum } from 'src/components/price-list/types';

export function translateSort(
  t: TranslateFunc,
  sortOption: SortOption
): React.ReactNode {
  return t(
    'common',
    `sort.${sortOption.toLowerCase()}` as keyof ParamsAndReturnTypes['common']
  );
}

export const getSortOptions = (
  currentSort: SortOptionEnum,
  renderAllOptions?: boolean
) => {
  const enumType = SortOptionEnum;
  const sortOptions = Object.keys(enumType).map(key => enumType[key]);
  return renderAllOptions
    ? sortOptions
    : sortOptions.filter(sortOption => sortOption !== currentSort);
};
